import { createFileRoute } from '@tanstack/react-router';
import { PurchasePage } from '@/components/purchases/purchase-page';

export const Route = createFileRoute('/expenses/debit-notes/$documentId')({
  component: View,
  validateSearch: (s: Record<string, unknown>): { apply?: string } =>
    typeof s['apply'] === 'string' ? { apply: s['apply'] } : {},
});

function View() {
  const { documentId } = Route.useParams();
  const { apply } = Route.useSearch();
  return <PurchasePage kind="debit_note" id={documentId} openApply={apply === '1'} />;
}
